<template>
  <div>
    <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space" v-model="activeTab">
      <!-- Waiting Room -->
      <tab-pane label="waiting-room">
        <template slot="label">
          <div style="height:4.3em;">
            <i class="fas fa-user-clock" @click="
                    $store.commit('setState', {
                      stateName: 'homePageActiveTab',
                      stateValue: 'waiting-room',
                    })
                  " style="height:3.8em;"> </i>
          </div>

        </template>
        <div style="height: 38em">
          <div class="col-lg-12 col-md-12 col-sm-12" v-if="appointments">
            <appointment-request-card v-for="appointment in appointments" :key="appointment._id" :appointment="appointment" @appointment-declined="getAppointments()"></appointment-request-card>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!appointments || appointments.length < 1">
            <i style="display: block;">{{$t("message.No requests queued for you at the moment")}}</i>
            <queue-svg style="max-width: 100%; height: auto; margin-top: 20em;"></queue-svg>
          </div>
        </div>
      </tab-pane>

      <!-- Assistant Room -->
      <tab-pane label="assistant-room" v-if="settings.consultancyParadigm == 'chat' || settings.directTelemedicine.consultancyParadigm == 'chat'">
        <template slot="label">
          <i class="fa fa-clinic-medical" @click="
                    $store.commit('setState', {
                      stateName: 'homePageActiveTab',
                      stateValue: 'assistant-room',
                    }); getAssistantAppointments();
                  "> </i>
        </template>
        <div style="height: 100%">
          <div class="col-lg-12 col-md-12 col-sm-12 h-100" v-if="assistantAppointments && assistantAppointments.length >0">
            <card class="card-stats" v-for="appointment in assistantAppointments" :key="appointment._id">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div class="row visit-details details">
                    <div class="col-3 col-md-3 pr-0">
                      <div class="row">
                        <div class="col-12 text-center">
                          <img :src="avatarImage" class="picture-src" style="
                                            width: 100px;
                                            border-radius: 50%;
                                            outline-color: transparent;
                                " />
                          <br />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 text-center">
                          <div v-if="appointment.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                            <span>
                              <i class="fa fa-mars"></i>
                            </span>
                          </div>
                          <div v-if="appointment.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                            <span>
                              <i class="fa fa-venus"></i>
                            </span>
                          </div>
                          <div v-if="appointment.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                            <span>
                              <i class="fa fa-transgender-alt"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-9 col-md-9 right">
                      <slot>
                        <div class="row">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-calendar-check"></i>
                            </span>
                          </div>
                          <div class="col-md-6 col-6 pl-0">
                            <span>{{
                                        getConsultationType(appointment.consultationType)
                                        }}</span>
                          </div>
                          <div v-if="unreadMessagesCount(appointment) > 0 && appointment.consultationType == 'telemed-direct' && settings.directTelemedicine.consultancyParadigm == 'chat'" style="position: absolute;right: 1em;display: flex;justify-content: center;align-items: end;">
                            <span style="color: white;position: absolute;font-size: 0.7em;margin-top: 0.4em;">
                              {{unreadMessagesCount(appointment)}}
                            </span>
                            <span>
                              <i class="far fa-comment-alt" style="font-weight: 900;color: var(--color-primary);font-size: 2em;"></i>
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-user"></i>
                            </span>
                          </div>
                          <div class="col-md-9 col-9 pl-0">
                            <span>{{ appointment.patient.firstName }}
                              {{ appointment.patient.lastName }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-info-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-9 col-9 pl-0">
                            <span>{{ appointment.patient.patientId }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-birthday-cake"></i>
                            </span>
                          </div>
                          <div class="col-md-9 col-9 pl-0">
                            <span>{{ getAge(appointment.patient.dob) }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-mobile"></i>
                            </span>
                          </div>
                          <div class="col-md-9 col-9 pl-0">
                            <span>{{ appointment.patient.mobileNumber }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-question"></i>
                            </span>
                          </div>
                          <div class="col-md-9 col-9 pl-0">
                            <span>{{ appointment.reason }}</span>
                          </div>
                        </div>
                        <div class="row" v-if="appointment.appointmentType == 'Scheduled'">
                          <div class="col-md-3 col-3 text-center">
                            <span>
                              <i class="fa fa-clock-o"></i>
                            </span>
                          </div>
                          <div class="col-md-9 col-9 pl-0">
                            <span>{{
                                            getAppointmentDatetime(appointment.scheduledTimestamp.start)
                                       }}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <!--                       <n-button type="primary" class="btn-padding btn-simple mr-2" round @click.native="declineVisit(appointment)">
                        <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                        Cancel
                      </n-button> -->
                <n-button style="height:3em;" type="primary" class="btn-padding mr-2 mb-2 mt-2" round @click.native="join(appointment)" v-if="
                        appointment.latestStatus != 'Completed' &&
                        (appointment.appointmentType != 'Scheduled' ||
                      (appointment.appointmentType == 'Scheduled' &&
                            (appointment.latestStatus == 'Assigned' ||
                      appointment.latestStatus == 'InProgress' || appointment.latestStatus == 'Paused')))
                        ">
                  <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                  {{ $t("message.Join") }}
                </n-button>
              </div>

              <loading :active.sync="LOADING" :can-cancel="false" :is-full-page="true" color="#2ca8ff">
                <template v-slot:after>
                  <h5 class="text-info">{{ loaderText }}</h5>
                </template>
              </loading>
            </card>
            <infinite-loading spinner="waveDots" @infinite="getAssistantAppointments">
              <span slot="no-more">{{ $t("message.No more appointments") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!assistantAppointments || assistantAppointments.length < 1">
            <i style="display: block;"> {{ $t("message.No Live Consults queued for you at the moment") }} </i>
            <queue-svg style="max-width: 100%; height: auto; margin-top: 20em;"></queue-svg>
          </div>
        </div>
      </tab-pane>
      <!-- Patient Monitoring -->
      <tab-pane label="patient-monitoring">
        <template slot="label">
          <i class="fas fa-user-injured" @click="
                    $store.commit('setState', {
                      stateName: 'homePageActiveTab',
                      stateValue: 'patient-monitoring',
                    })
                  "></i>
        </template>
        <div style="padding-right: 0px;  padding-left: 0px;" class="container h-100">
          <div class="row h-100">
            <div class="col-12 h-100">
              <div class="col-md-12 col-12" align="center">
                <cool-select class="custom-input" :placeholder="'Search'" ref="select" disable-filtering-by-search @search="searchPatients" :resetSearchOnBlur="false" :items="patients">
                  <template slot="item">
                    <div>
                    </div>
                  </template>
                </cool-select>
              </div>
              <div class="col-xl-4 col-md-6" style="height: calc(100% - 50px); overflow-y: scroll;">
                <card class="card-stats" v-for="patient in patients" :key="patient._id" @click.native="viewPatientHistory(patient)">
                  <div class="statistics statistics-horizontal">
                    <div class="info info-horizontal">
                      <div class="row">
                        <div class="col-4 col-md-4">
                          <div class="row">
                            <div class="col-12">
                              <div class="profile-image" :style="{
                                      backgroundImage:
                                        'url(' +
                                        (patient.profileImage
                                          ? baseUrl + '/file/' + patient.profileImage
                                          : avatarImage) +
                                        ')',
                                    }"></div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 text-center">
                              <div v-if="patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                                <span>
                                  <i class="fa fa-mars"></i>
                                </span>
                              </div>
                              <div v-if="patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                                <span>
                                  <i class="fa fa-venus"></i>
                                </span>
                              </div>
                              <div v-if="patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                                <span>
                                  <i class="fa fa-transgender-alt"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-8 col-md-8 right">
                          <slot>
                            <div class="row">
                              <div class="col-md-1 col-1">
                                <span>
                                  <i class="fa fa-user"></i>
                                </span>
                              </div>
                              <div class="col-md-10 col-10">
                                <span>{{ patient.firstName }} {{ patient.lastName }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-1">
                                <span>
                                  <i class="fa fa-info-circle"></i>
                                </span>
                              </div>
                              <div class="col-md-10 col-10">
                                <span>{{ patient.patientId }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-1">
                                <span>
                                  <i class="fa fa-birthday-cake"></i>
                                </span>
                              </div>
                              <div class="col-md-10 col-10">
                                <span>{{ getAge(patient.dob) }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-1">
                                <span>
                                  <i class="fa fa-mobile"></i>
                                </span>
                              </div>
                              <div class="col-md-10 col-10">
                                <a :href="`tel:${patient.mobileNumber}`">{{ patient.mobileNumber }}</a>
                              </div>
                            </div>
                          </slot>
                        </div>
                      </div>
                      <div class="row" v-if="patient.latestVitals && patient.vitalProfile">
                        <div class="col-md-4 col-4 vitals" align="center" v-for="vital in patient.latestVitals.vitalsData" :key="vital.name">
                          <span style="color: rgba(140, 138, 138, 0.87);font-size:10px;font-weight: normal;vertical-align: super;float: left;" v-if="patient.vitalProfile[vital.name]">
                            {{patient.vitalProfile[vital.name].identifier}}
                          </span>
                          <span style="color: rgba(140, 138, 138, 0.87);font-size:10px;font-weight: normal;vertical-align: super;float: left;" v-if="!patient.vitalProfile[vital.name]">
                            {{vital.name}}
                          </span>
                          <br />
                          <span style="font-size:15px;font-weight: 400; color:rgb(33, 150, 243)">
                            {{vital.value}}
                            <sub style="font-size: 0.6em">{{vital.unit}}</sub>
                          </span>

                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col-md-12 col-12" align="center">
                          <div>{{ $t("message.No vitals") }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </card>
                <infinite-loading spinner="waveDots" @infinite="getPatients">
                  <span slot="no-more">{{ $t("message.No more patients") }}</span>
                  <span slot="no-results"></span>
                </infinite-loading>
              </div>
            </div>
          </div>
        </div>

      </tab-pane>
    </tabs>
    <need-help-modal></need-help-modal>

  </div>

</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import { TabPane, Tabs } from "src/components";

import socket from "@/services/socket";

import AppointmentRequestCard from "@/pages/carenation/components/AppointmentRequestCard.vue";
import avatarImage from "@/assets/img/proAvatar.png";

import QueueSvg from "../components/svg_images/QueueSvg.vue";
import NeedHelpModal from "../components/NeedHelpModal";

export default {
  name: "home",
  components: {
    TabPane,
    Tabs,
    AppointmentRequestCard,
    QueueSvg,
    NeedHelpModal,
  },

  data() {
    return {
      appointments: [],
      patients: [],
      avatarImage,
      assistantAppointments: [],
      patientListpagination: {
        totalPages: 0,
        pageSize: 2,
        pageNumber: 1,
      },
      assistantRoomPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      patientSearch: null,
      doctors: [],
      loader: null,
      LOADING: false,
      loaderText: "",
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    activeTab() {
      return this.$store.state.homePageActiveTab;
    },
  },

  methods: {
    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    async getAppointments() {
      this.appointments = (
        await this.$store.dispatch("getAppointmentsForCareco", this.user)
      ).data;
      this.$forceUpdate();
    },
    async getAssistantAppointments($state) {
      try {
        if (!$state) {
          this.assistantAppointments = [];
          this.assistantRoomPagination = {
            pageNumber: 1,
            totalPages: 0,
            pagesize: 2,
          };
        }
        this.doctors = await this.$store.dispatch("getProvidersByAssociation", {
          userId: this.user._id,
          associationType: "assistant",
        });
        let doctorIds = [];
        for (let doctor of this.doctors) {
          doctorIds.push(doctor._id);
        }
        let res = await this.$store.dispatch("getAppointmentsByDoctorIds", {
          doctorIds: doctorIds,
          pageNumber: this.assistantRoomPagination.pageNumber,
          pageSize: 2,
        });
        if (res.data && res.data.length) {
          this.assistantAppointments.push(...res.data);
          this.assistantRoomPagination.totalPages = res.totalPages;
          this.assistantRoomPagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
      } catch (e) {
        console.log(e);
      }
    },
    unreadMessagesCount(appointment) {
      if (
        appointment.unreadMessagesCount &&
        appointment.unreadMessagesCount.hasOwnProperty(this.user._id)
      ) {
        return appointment.unreadMessagesCount[this.user._id];
      } else {
        return 0;
      }
    },
    getFormattedDob(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getConsultationType(consultationType) {
      return consultationType == "inperson"
        ? this.$t("message.InPerson")
        : this.$t("message.Telemedicine");
    },
    getAppointmentDatetime(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY, hh:mm a");
    },
    join(appt) {
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appt,
      });

      this.$router.push("telemed");
    },
    declineVisit() {},
    async searchPatients(searchString) {
      let caregroups = this.user.caregroups.map((caregroup) =>
        typeof caregroup == "object" ? caregroup._id : caregroup
      );
      try {
        if (searchString.length > 2) {
          this.patientListpagination = {
            pageNumber: 1,
            totalPages: 0,
            pageSize: 4,
          };
          let response = await this.$store.dispatch(
            "searchPatientsByCaregroups",
            {
              caregroups: caregroups,
              searchStr: searchString,
              patientListpagination: this.patientListpagination,
            }
          );

          this.patientListpagination = {
            totalPages: response.totalPages,
            pageSize: response.pageSize,
            pageNumber: response.pageNumber,
          };

          this.patients = response.data;

          this.getLatestVitalsAndVitalsRanges();
        } else {
          this.getPatients();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPatients($state) {
      if (!$state) {
        this.patients = [];
        this.patientListpagination = {
          pageNumber: 1,
          totalPages: 0,
          pageSize: 4,
        };
      }

      let caregroups = this.user.caregroups.map((caregroup) =>
        typeof caregroup == "object" ? caregroup._id : caregroup
      );
      try {
        let response = await this.$store.dispatch("getPatientsByCaregroups", {
          caregroups: caregroups,
          patientListpagination: this.patientListpagination,
        });

        if (response.data && response.data.length) {
          this.patients.push(...response.data);
          this.patientListpagination.totalPages = response.totalPages;
          this.patientListpagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }

        this.getLatestVitalsAndVitalsRanges();
      } catch (err) {
        console.log("Error fetching patients " + err);
      }
    },
    async getLatestVitalsAndVitalsRanges() {
      for await (const patient of this.patients) {
        this.getLatestVitals(patient.patientId);
      }

      for await (const [index, patient] of this.patients.entries()) {
        let patientEp = null;
        for (let ep of patient.endpoints) {
          if (ep.isDefault && ep.name) {
            patientEp = ep.name;
            break;
          }
        }
        if (patientEp) {
          this.patients[index].deviceStatus = "offline";
          try {
            let endpoint = await this.$store.dispatch(
              "getEndpointDetails",
              patientEp
            );

            let deviceProfile = [];
            //Get device profile from configurations
            let response = await this.$store.dispatch(
              "getConfigurationByEndpointId",
              {
                endpointId: endpoint._id,
                type: "deviceProfile",
              }
            );
            if (response && response.value) {
              deviceProfile = response.value;
            }

            let tempDeviceProfile = {};
            deviceProfile.forEach((device) => {
              device.vitals.forEach((vital) => {
                tempDeviceProfile[vital.identifier] = {
                  devicename: device.displayName[this.$i18n.locale],
                  identifier: vital.identifier,
                  range: {
                    max: vital.normalRange ? vital.normalRange.max : "",
                    min: vital.normalRange ? vital.normalRange.min : "",
                  },
                  unit: vital.unit.primary,
                };
              });
            });

            deviceProfile = tempDeviceProfile;

            patient.vitalProfile = deviceProfile;
            let temp = this.patients;
            this.patients = [];
            this.patients = temp;
          } catch {
            console.log(
              "Error fetching endpoint for Patient with ID: " +
                patient.patientId
            );
          }
        }
      }
    },
    async getLatestVitals(patientId) {
      try {
        let data = await this.$store.dispatch("getLatestVitals", patientId);
        if (data) {
          let patient = this.patients.find((e) => e.patientId == patientId);
          if (patient) {
            patient.latestVitals = data;
            let temp = this.patients;
            this.patients = [];
            this.patients = temp;
          }
        }
      } catch (err) {
        let patient = this.patients.find((e) => e.patientId == patientId);
        if (patient) {
          patient.latestVitals = null;
          let temp = this.patients;
          this.patients = [];
          this.patients = temp;
        }
        console.log(
          "Error fetching latest vitals for Patient with ID: " + patientId + err
        );
      }
    },
    viewPatientHistory(patient) {
      this.$store.commit("setState", {
        stateName: "patientId",
        stateValue: patient.patientId,
      });

      this.$router.push("patienthistory");
    },
    initSocket() {
      console.log("CareCo Home - initSocket");
      //joining socket to be extra sure
      //Join User Room
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });

      //subscribe to mqtt topic using socket
      socket.emit("subscribe", { topic: this.user._id });

      //Join all caregroup rooms
      this.user.caregroups.forEach((caregroup) => {
        socket.emit("joinRoom", { type: "caregroup", id: caregroup });
        socket.emit("subscribe", { topic: caregroup.name });
      });
    },
  },

  async mounted() {
    let that = this;

    if (this.user) {
      try {
        // available tabs
        let tabs = [
          {
            name: "requestQueue",
            id: "waiting-room",
          },
          {
            name: "assistantRoom",
            id: "assistant-room",
          },
          {
            name: "patientMonitoring",
            id: "patient-monitoring",
          },
        ];
        // set first enabled tab as active
        if (this.activeTab) {
          this.changeAppHeaderText(this.activeTab);
        } else {
          for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab == "assistantRoom") {
              this.$store.commit("setState", {
                stateName: "homePageActiveTab",
                stateValue: tab.id,
              });
              this.changeAppHeaderText(tab.id);
              break;
            }
            if (this.user.tabsEnabled[tab.name]) {
              this.$store.commit("setState", {
                stateName: "homePageActiveTab",
                stateValue: tab.id,
              });
              this.changeAppHeaderText(tab.id);
              break;
            }
          }
        }

        this.$root.onBackButton = () => {
          let that = this;
          if (this.$sidebar.showSidebar) {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
          } else {
            swal
              .fire({
                title: that.$t("message.Are you sure?"),
                confirmButtonText: that.$t("message.Exit"),
                showCancelButton: true,
                cancelButtonText: that.$t("message.Stay"),
              })
              .then(async (result) => {
                if (result && result.value) {
                  navigator.app.exitApp();
                }
              });
          }
        };
        await this.$store.dispatch("getSettings");
        this.getAppointments();
        this.getAssistantAppointments();

        this.initSocket();
        window.initSocket = this.initSocket;

        socket.on("appointmentCreated", function (data) {
          that.getAppointments();
        });

        socket.on("appointmentRequested", () => {
          this.getAppointments();
        });

        socket.on("appointmentRequestCancelled", function (data) {
          that.getAppointments();
        });

        socket.on("latestVitalsUpdate", function (socketData) {
          console.log("latestVitalsUpdate", socketData);
          that.getPatients(); // TODO - Optimize this
        });

        socket.on("appointmentListUpdate", async function () {
          console.log("appointmentListUpdate");
          that.getAssistantAppointments();
        });

        window.onAppResume = () => {
          setTimeout(() => {
            that.getAppointments();
          }, 0);
        };

        this.getPatients();
        //Subscribing to vitals topic
        let userDetails = await this.$store.dispatch(
          "getUserDetails",
          this.user._id
        );
        for (let i in userDetails.caregroups) {
          let vitalTopic =
            this.instance +
            "-" +
            this.user.tenant.name +
            "-" +
            userDetails.caregroups[i].name +
            "-vitals";
          cordova.plugins.firebase.messaging.subscribe(vitalTopic);
          console.log("Subscribed to topic - " + vitalTopic);
        }

        let user = await this.$store.dispatch("getUserById", this.user._id);

        if (user.endpoint) {
          let endpoint = await this.$store.dispatch(
            "getEndpoint",
            user.endpoint
          );
          user.endpoint = endpoint;
        }

        localStorage.user = JSON.stringify(user);
      } catch (e) {
        console.log(e);
      }

      let user = await this.$store.dispatch("getUserById", this.user._id);
      try {
        let userEndpoint = await this.$store.dispatch(
          "getEndpointByDeviceType",
          this.user._id
        );
        if (userEndpoint && userEndpoint._id) {
          user.endpoint = userEndpoint;
        }
      } catch (e) {
        console.log(e);
      }

      localStorage.user = JSON.stringify(user);
    } else {
      console.log("no user");
      this.$router.push({ path: "/signin" });
    }
  },

  beforeDestroy() {
    socket.off("appointmentCreated");
    socket.off("appointmentRequested");
    socket.off("appointmentRequestCancelled");
    this.$root.onBackButton = null;

    window.initSocket = null;
  },
};
</script>


<style scoped>
/deep/ .tab-content {
  height: calc(100% - 68px);
  position: relative;
}
.content > div,
.content > div > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}
.btn-padding {
  padding: 5px 15px;
  margin-right: 1em;
}
.patient-details .right .fa {
  color: rgba(44, 44, 44, 0.69);
}
.profile-image {
  height: 80px;
  max-width: 100px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 50%;
}

.vitals {
  border-bottom: solid 1px #e0e0e0;
  border-right: solid 1px #e0e0e0;
  padding-left: 16px;
}

.vitals:nth-child(3) {
  border-bottom: solid 1px #e0e0e0;
  padding-left: 16px;
  border-right: 0px;
}

.vitals:nth-child(6) {
  border-bottom: solid 1px #e0e0e0;
  padding-left: 16px;
  border-right: 0px;
}

.vitals:nth-child(9) {
  border-bottom: solid 1px #e0e0e0;
  padding-left: 16px;
  border-right: 0px;
}

.vitals:nth-last-child(-n + 3) {
  border-bottom: 0px;
  padding-left: 16px;
}

.vitals:nth-last-child() {
  border-right: 0px;
  padding-left: 16px;
}

/deep/ .vld-icon {
  text-align: center;
}

/* .vitals:nth-child(odd).icu {
  border-right: none;
  border-bottom: none;
}
 */
/* .vitals:nth-child(even).icu {
  padding-left: 0px;
  border-bottom: none;
}

.vitals:nth-last-child(1),
.vitals:nth-last-child(2) {
  border-bottom: none;
} */
</style>
